import type {
    GroupByType,
    SwingTimingData,
} from 'leaderboard/scripts/swing-path/types/globals'

type PlayerImageSource = 'headshot' | 'midfield'

type GetImageUrlOptions = {
    playerImageSource?: PlayerImageSource
    playerImageSize?: number
}

export default function getImageUrl(
    type: GroupByType,
    row: SwingTimingData,
    options: GetImageUrlOptions = {}
) {
    const { playerImageSource = 'headshot', playerImageSize = 180 } = options

    if (type === 'pitcher' || type === 'batter') {
        if (playerImageSource === 'midfield') {
            return `https://midfield.mlbstatic.com/v1/people/${row.id}/spots/${playerImageSize}`
        }

        return `https://midfield.mlbstatic.com/v1/people/${row.id}/mlb/${playerImageSize}`
    }

    if (type === 'pitching-team' || type === 'batting-team') {
        return `https://midfield.mlbstatic.com/v1/team/${row.id}/spots/108`
    }

    return '/site-core/images/savant-mlb.svg'
}
